
<div class="bw-menu-legacy-items">
  <ng-content></ng-content>
</div>
